/**
 * @file PDotObjField.jsx
 * @description input field for mutiple pDots for associated genomeBuilds
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Sept 17, 2025.  Simon Butters passed on this day. He was a force.
 */
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FormLabel from '@mui/material/FormLabel';

import { objectExists } from 'src/@common/utilities';
import VeriomeTextField from 'src/components/fieldComponents/VeriomeTextField';

function PDotObjField(props) {
    const {
        containerSxStyle,
        fieldErrors,
        formFields,
        handleBlur,
        handleChange,
    } = props;

    const fieldWidth = 220;

    return (

        <Card variant="outlined" sx={containerSxStyle}  >

            <CardContent>
                <FormLabel sx={{ mt: '3px', mb: '5px' }} component="legend">P-Dot</FormLabel>

                {objectExists(formFields) &&

                    <>
                        <VeriomeTextField
                            fieldErrors={fieldErrors}
                            fieldLabel={'HG-38 P-Dot'}
                            fieldName={'hg38.pDot'}
                            currentValue={formFields.hg38.pDot ? formFields.hg38.pDot : ''}
                            helpText={''}
                            isFocus={false}
                            isRequired={false}
                            isMultiline={false}
                            sxStyle={{
                                width: fieldWidth,
                                mr: '10px',
                            }}
                            handleBlur={() => {
                                handleBlur('hg38.pDot');
                            }}
                            handleChange={(event) => {
                                handleChange(event, 'hg38.pDot');
                            }}
                        />

                        <VeriomeTextField
                            fieldErrors={fieldErrors}
                            fieldLabel={'HG-38 RefSeq'}
                            fieldName={'hg38.refSeq'}
                            currentValue={formFields.hg38.refSeq ? formFields.hg38.refSeq : ''}
                            helpText={''}
                            isFocus={false}
                            isRequired={false}
                            isMultiline={false}
                            sxStyle={{
                                width: fieldWidth,
                                mr: '10px',
                            }}
                            handleBlur={() => {
                                handleBlur('hg38.refSeq');
                            }}
                            handleChange={(event) => {
                                handleChange(event, 'hg38.refSeq');
                            }}
                        />

                    </>
                }

            </CardContent>

        </Card>
    );
}

PDotObjField.propTypes = {
    pDotOptions: PropTypes.array,
    containerSxStyle: PropTypes.object,
    fieldErrors: PropTypes.object.isRequired,
    formFields: PropTypes.object.isRequired,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func.isRequired,
};

export default PDotObjField;
